import React from 'react';
import { Link } from 'react-router-dom';
import SiteProofLogo from '../../../components/SiteProofLogo';

const LegalPageFooter = ({ crossLinkLabel, crossLinkTo }) => {
  return (
    <footer className="bg-slate-900 border-t border-slate-800 py-8 mt-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <SiteProofLogo size="sm" />
          <div className="flex items-center gap-4">
            {crossLinkTo && (
              <Link to={crossLinkTo} className="text-xs text-slate-400 hover:text-white transition-colors">
                {crossLinkLabel}
              </Link>
            )}
            <Link to="/" className="text-xs text-slate-400 hover:text-white transition-colors">
              Back to SiteProof
            </Link>
          </div>
          <div className="text-center sm:text-right">
            <p className="text-xs text-slate-500">&copy; 2026 SiteProof Ltd. All rights reserved.</p>
            <p className="text-xs text-slate-600 mt-0.5">SiteProof Ltd is registered in England and Wales. Company number: 17085500.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LegalPageFooter;
